import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses, accessNested } from 'utils/utils';
import { getVideoData } from 'services/youtubeApi';
import Button from 'components/bolt/button/button';
import s from 'components/bolt/videos/playlist/playlistItem.sss';

export default class VideosPlaylistItem extends Component {
	async componentDidMount() {
		const { item } = this.props;
		if (item.youtubeId && !item.thumbSrc) {
			const videoData = await getVideoData(item.youtubeId);
			const thumbSrc = videoData?.items?.[0]?.snippet?.thumbnails?.medium?.url || '';
			this.setState({ thumbSrc });
		}
	}

	render(props) {
		const { item, onClick, activeVideo, forwardedRef, delayItems } = props;

		const faded = activeVideo && activeVideo.key !== item?.key;
		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
		const thumbSrc = item.thumbSrc || this.state?.thumbSrc;
		const thumbStyle = {
			backgroundImage: thumbSrc ? 'url("' + thumbSrc + '")' : ''
		};

		return (
			<Button class={joinClasses({ s, container: true, faded, delayItems })} forwardedRef={forwardedRef} trigger={onClick}>
				<div class={s.thumbBtn}>
					<div class={s.thumb} style={thumbStyle} role="img" ariaLabel={item.thumbAria || item.name} />
				</div>
				<div class={joinClasses(s.name, fontStyles.videoTitles)}>{item.name}</div>
			</Button>
		);
	}
}
